import { Timestamp } from '@griply/types';
import { getTimeLeftLabel } from '@griply/utils';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'shared/components/ui/icon';
import { useToday } from 'shared/contexts/today';
import { useI18nLocale } from 'shared/lib/react-i18next/use-i18n-locale';

import * as Styled from './time-left.style';

export type TimeLeftProps = {
  startIcon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  date: Timestamp;
  isShort?: boolean;
  isMidShort?: boolean;
  isSmallIcon?: boolean;
  noColor?: boolean;
  isCompleted?: boolean;
  // Pill presentation used by the task card: grey background, caption type.
  isChip?: boolean;
};

export const TimeLeft: React.FC<TimeLeftProps> = ({
  date,
  startIcon,
  isShort,
  isMidShort,
  isSmallIcon,
  noColor,
  isCompleted,
  isChip,
}) => {
  const containerRef = useRef<HTMLSpanElement>(null);
  const today = useToday();
  const { t } = useTranslation();
  const language = useI18nLocale();

  const { label, isOverdue, isLastWeek } = getTimeLeftLabel(date, {
    today,
    t,
    language,
    short: isShort,
    midShort: isMidShort,
    isCompleted,
  });

  return (
    <Styled.Container
      ref={containerRef}
      $overdue={!isCompleted && isOverdue}
      $lastWeek={!isCompleted && isLastWeek}
      $noColor={!!noColor}
      $chip={!!isChip}
      $isCompleted={!!isCompleted}
    >
      {!!startIcon && (
        <Styled.IconContainer $isSmall={!!isSmallIcon || !!isChip}>
          <Icon icon={startIcon} />
        </Styled.IconContainer>
      )}

      <Styled.Label $chip={!!isChip}>{label}</Styled.Label>
    </Styled.Container>
  );
};
